<template>
  <video ref="previewPlayer" controls :poster="poster" />
</template>

<script>
import Hls from "hls.js";

/** vuex */
import { mapState } from "vuex";

// @group Media/Video
// Trimmed video preview
export default {
  name: "PreviewPlayer",
  props: {
    // preview start time UNIX timestamp
    beginTime: {
      type: Number,
      required: true
    },
    // preview end time UNIX timestamp
    endTime: {
      type: Number,
      required: true
    },
    // play/pause preview
    paused: {
      type: Boolean,
      default: true
    },
    // poster link
    poster: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      /** time to reload (in ms) when stream failed */
      reloadStreamInterval: 5000
    };
  },
  computed: {
    ...mapState({
      /** DVR parameters */
      streamServer: state => state.services.host,
      app: state => state.services.app,
      stream: state => state.services.stream,
      wseToken: state => state.services.stream_token
    }),
    // @vuese
    // nDVR parameters endpoint
    ndvrStream() {
      const link = `${this.streamServer}/ndvr/${this.stream}/playlist.m3u8?token=${this.wseToken}&DVR`;
      return link;
    },
    // @vuese
    // Get link to cropped video preview
    ndvrPreviewLink() {
      return `${this.ndvrStream}&dvrplayliststart=${this.cropBeginInMS}&dvrplaylistend=${this.cropEndInMS}`;
    },
    // @vuese
    // Crop begin unix timestamp in milliseconds
    cropBeginInMS() {
      return Math.round(this.beginTime * 1000);
    },
    // @vuese
    // Crop end unix timestamp in milliseconds
    cropEndInMS() {
      return Math.round(this.endTime * 1000);
    }
  },
  watch: {
    visible(e) {
      if (e) {
        this.hls.loadSource(this.ndvrPreviewLink);
      }
    },
    // @vuese
    // Play/pause player
    paused() {
      if (this.$refs.previewPlayer) {
        this.syncPaused();
      }
    },
    // @vuese
    // Reload stream when link has changed
    ndvrPreviewLink() {
      if (this.ndvrPreviewLink) {
        this.loadSource();
      }
    }
  },
  mounted() {
    /** init player */
    this.syncPaused();
    const player = this.$refs.previewPlayer;
    player.addEventListener("play", () => this.$emit("update:paused", false));
    player.addEventListener("pause", () => this.$emit("update:paused", true));

    /** init source */
    if (this.ndvrPreviewLink) {
      this.loadSource();
    }
  },
  methods: {
    // @vuese
    // Reload stream source
    loadSource() {
      // const source = this.ndvrPreviewLink;
      const player = this.$refs.previewPlayer;
      if (this.hls) {
        this.hls.destroy();
      }

      /** HLS initializing */
      this.hls = new Hls();

      this.hls.attachMedia(player);

      // this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
      //   this.hls.loadSource(source);
      // });

      this.hls.on(Hls.Events.ERROR, (error, data) => {
        this.handleStreamFailed(data);
      });
    },
    // @vuese
    // Handle stream HLS error
    handleStreamFailed({ type, details, fatal }) {
      console.error(`HLS stream error: ${type} - ${details}`);

      /** Reload stream only when it won't be reloaded itself */
      if (fatal) {
        console.error(
          `Stream ${this.timedLink} was failed and will be reloaded`
        );
        setTimeout(() => this.loadSource(), this.reloadStreamInterval);
      }
    },
    // @vuese
    // Update player state with property value
    syncPaused() {
      if (this.paused) {
        this.$refs.previewPlayer.pause();
      } else {
        this.$refs.previewPlayer.play();
      }
    }
  }
};
</script>
